"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDownloadEmailFilename = void 0;
var file_extension_1 = __importDefault(require("file-extension"));
/**
 * getDownloadEmailFilename
 * if a filename does not have a file extension of .msg
 * return the file name email-${fileId}.eml
 *
 * @returns
 */
function getDownloadEmailFilename(fileId, fileName) {
    var filenameFallback = fileName || '';
    var extension = (0, file_extension_1.default)(filenameFallback);
    return extension !== 'msg' ? "email-".concat(fileId, ".eml") : filenameFallback;
}
exports.getDownloadEmailFilename = getDownloadEmailFilename;
